import { useState, useEffect } from 'react';
import { getIsAccountAdmin } from '../../services/authServices';

export interface UseUserIsAdmin {
  (): {
    isAdmin: boolean;
    isChecked: boolean;
    isModerator: boolean;
  }
}

export const useUserIsAdmin: UseUserIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isModerator, setIsModerator] = useState<boolean>(false);

  useEffect(() => {
    getIsAccountAdmin().then((res) => {
      setIsAdmin(res.data.is_admin);
      setIsModerator(res.data.is_superuser);
      setIsChecked(true);
    });
  }, []);

  return { isAdmin, isChecked, isModerator };
};
